/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeCounselorDocumentsResponse
 */
export interface MergeCounselorDocumentsResponse {
    /**
     * 
     * @type {string}
     * @memberof MergeCounselorDocumentsResponse
     */
    documentId: string;
}

/**
 * Check if a given object implements the MergeCounselorDocumentsResponse interface.
 */
export function instanceOfMergeCounselorDocumentsResponse(value: object): value is MergeCounselorDocumentsResponse {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    return true;
}

export function MergeCounselorDocumentsResponseFromJSON(json: any): MergeCounselorDocumentsResponse {
    return MergeCounselorDocumentsResponseFromJSONTyped(json, false);
}

export function MergeCounselorDocumentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeCounselorDocumentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
    };
}

export function MergeCounselorDocumentsResponseToJSON(json: any): MergeCounselorDocumentsResponse {
    return MergeCounselorDocumentsResponseToJSONTyped(json, false);
}

export function MergeCounselorDocumentsResponseToJSONTyped(value?: MergeCounselorDocumentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
    };
}

